import {
  Component, OnInit, Input, ChangeDetectionStrategy,
  Output, EventEmitter, ChangeDetectorRef, OnChanges, SimpleChanges
} from '@angular/core';

import { FilterApplier, FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { PriceRangeFilter } from '@shared/filters/entities/fetch-filters.response';
import { RadioButtonAlign } from '@design-system/components/organisms/radio-button/entities/radio-button.types';
import {
  TypographyFontFamily, TypographyFontSize, TypographyColor
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-radio-filter',
  templateUrl: './radio-filter.component.html',
  styleUrls: ['./radio-filter.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RadioFilterComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() type: string;
  @Input() options: PriceRangeFilter[] = [];
  @Input() index = -1;
  @Input() isMobile = false;
  @Input() isOpenBox: boolean;
  @Input() pickedTotalDiscountPercentage: number;
  @Input() individualFilter: boolean

  @Output() filter: EventEmitter<FilterApplier> = new EventEmitter<FilterApplier>();

  public seeMore = false;
  public activeDisabled = false;
  public arrowFilterSelector = 'arrow-filter-';
  public radioSelected: number;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  private readonly maxViewOptions = 5;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.setRadioSelected();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['pickedTotalDiscountPercentage']) {
      this.setRadioSelected();
      this.detectChanges();
    }
  }

  get radioButtonAlign(): RadioButtonAlign {
    return this.isMobile ? RadioButtonAlign.Right : RadioButtonAlign.Left;
  }

  get visibleOptions(): PriceRangeFilter[] {
    return this.options ? this.options?.filter(x => x?.Ocurrence > 0) : this.options;
  }

  get seeMoreActive(): boolean {
    return this.options && this.options.length > this.maxViewOptions;
  }

  public isChecked(lowerBound: number): boolean {
    return lowerBound === this.radioSelected;
  }

  public toggleCheckboxOptions(): void {
    this.isOpenBox = !this.isOpenBox;
  }

  public toggleMoreFliters(): void {
    this.seeMore = !this.seeMore;
  }

  public selectOption(option: PriceRangeFilter): void {
    this.radioSelected = option.LowerBound;
    this.filter.emit({ type: this.type as FilterTypes, value: option.LowerBound, removable: false });
    this.detectChanges();
  }

  private setRadioSelected(): void {
    this.radioSelected = this.pickedTotalDiscountPercentage;
    this.detectChanges();
  }

  private detectChanges(): void {
    this.changeDetector.detectChanges();
  }
}

